import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Apollo} from 'apollo-angular';
import { ISolutionHistory, ListSolutionHistorysQuery } from '@ebb-v2/ebb-integration';
import { SolutionHistoryApiService } from '../index';

@Injectable({
    providedIn: 'root'
  })
  export class SolutionHistoryGqlService implements SolutionHistoryApiService {

    constructor(
      private apollo: Apollo
    ) { }

    public getSolutionHistoryList(): Observable<ISolutionHistory[]> {
      return this.apollo
        .query ({
          query: ListSolutionHistorysQuery,
          fetchPolicy: 'network-only'
        })
        .pipe(map(result => result.data['solutionhistorys'] as ISolutionHistory[]));
    }

  }
